const payokMethods = {
  "payok_bniva": "payok_BNIVA",
  "payok_cimbva": "payok_CIMBVA",
  "payok_permatava": "payok_PermataVA",
  "payok_briva": "payok_BRIVA",
  "payok_mandiriva": "payok_MandiriVA",
  "payok_bcava": "payok_BCAVA",
  "payok_bsiva": "payok_BSIVA",
  "payok_bncva": "payok_BNCVA",
  "payok_inava": "payok_INAVA",
  "payok_qris": "payok_QRIS",
  "payok_staticqris": "payok_StaticQRIS",
  "payok_danawallet": "payok_DANAWALLET",
  "payok_ovowallet": "payok_OVOWALLET",
  "payok_shopeepay-app": "payok_SHOPEEPAY-APP",
  "payok_shopeepay-web": "payok_SHOPEEPAY-WEB",
  "payok_linkaja-app": "payok_LINKAJA-APP",
  "payok_linkaja-web": "payok_LINKAJA-WEB",
  "payok_conveniencestore": "payok_ConvenienceStore",
  "payok_momo": "payok_Momo",
  "payok_zalopay": "payok_ZaloPay",
  "payok_viettelpay": "payok_ViettelPay",
  "payok_techcomvietqr": "payok_TechcomVietQR",
  "payok_acbvietqr": "payok_ACBVietQR",
  "payok_mbvietqr": "payok_MBVietQR",
  "payok_bidvqr": "payok_BIDVQR",
  "payok_vpbankqr": "payok_VPBankQR",
  "payok_bankva": "payok_BankVA",
  "payok_truemoney": "payok_TRUEMONEY",
  "payok_bank transfer": "payok_Bank Transfer",
  "payok_promptpay": "payok_PROMPTPAY",
  "payok_pix": "payok_PIX",
  "payok_bkmexpress": "payok_BKMExpress",
  "payok_paparawallet": "payok_PAPARAWALLET",
  "payok_papara qr": "payok_Papara QR",
  "payok_iban": "payok_IBAN",
  "payok_creditcard": "payok_CreditCard",
  "payok_debitcard": "payok_DebitCard",
  "payok_nequi_push": "payok_NEQUI_PUSH",
  "payok_efecty": "payok_EFECTY",
  "payok_corresponsal_bancolombia": "payok_CORRESPONSAL_BANCOLOMBIA",
  "payok_pse": "payok_PSE",
  "payok_bre-b": "payok_Bre-B",
  "payok_upi": "payok_UPI",
  "payok_bkash": "payok_BKASH",
  "payok_nagad": "payok_NAGAD",
  "payok_upay": "payok_UPAY"
}


export default payokMethods;